<template>
  <router-view />
</template>

<script>
export default {
  name: "app-customer"
};
</script>

<style lang="scss" scoped></style>
